export const firstToUpperCase = (str: string, once?: boolean) =>
  once
    ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    : str
        .split(" ")
        .map((i) => i.charAt(0).toUpperCase() + i.slice(1).toLowerCase())
        .join(" ")
